import type { Theme, DesignTokens } from './types';
import { defaultDesignTokens } from './tokens';
import React from 'react';
import { createTheme } from './helper';

export type ThemeContextValue = { theme: Theme };

const ThemeContext = React.createContext<ThemeContextValue>({
  theme: createTheme(defaultDesignTokens),
});

export interface ThemeProviderProps {
  tokens?: DesignTokens;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  tokens = defaultDesignTokens,
  children,
}) => {
  const value = React.useMemo(() => ({ theme: createTheme(tokens) }), [tokens]);

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextValue => React.useContext(ThemeContext);
